export default __webpack_public_path__ + "static/media/ancestors.c6aca829.png";